"use client";

import { motion, useReducedMotion } from "framer-motion";
import {
  DashboardMockup,
  type DashboardMockupPreview,
} from "./mockup/dashboard-mockup";
import { CAMERA_SPRING, cameraTransform } from "./mockup/camera";

interface WizardRightPanelProps {
  currentStep: number;
  preview?: DashboardMockupPreview;
}

/**
 * Decorative app preview beside the onboarding form. A single dashboard canvas
 * is rebuilt 1:1 in the DOM; the "camera" smoothly zooms/pans across it as the
 * user advances through all steps.
 */
export function WizardRightPanel({ currentStep, preview }: WizardRightPanelProps) {
  const reduceMotion = useReducedMotion();
  const dashboardCamera = cameraTransform(currentStep);

  const spring = reduceMotion ? { duration: 0.25 } : CAMERA_SPRING;

  return (
    <div className="relative hidden min-w-0 flex-1 overflow-hidden border-l bg-[#0e0e10] lg:flex">
      {/* dashboard camera layer */}
      <motion.div
        className="absolute left-0 top-0"
        style={{ transformOrigin: "0 0", willChange: "transform" }}
        initial={false}
        animate={{
          x: dashboardCamera.x,
          y: dashboardCamera.y,
          scale: dashboardCamera.scale,
        }}
        transition={spring}
      >
        <DashboardMockup preview={preview} />
      </motion.div>

      {/* linear gradient (bottom → top) to anchor the preview in the panel */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "linear-gradient(to top, rgb(255 255 255 / 0.14) 0%, rgb(255 255 255 / 0.05) 30%, transparent 70%)",
        }}
      />
    </div>
  );
}
